let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5GgP6")).then(() => parcelRequire('fHjAM'));